import { inject, Injectable } from "@angular/core";
import { ComparatorOperators, ConformanceToKiRsSummaryField, ConformanceToKiRsSummaryQueryComplexInput, ConformanceToKiRsSummarySimpleQueryInput, ExportKirsSummaryGQL, ExportKirsSummaryQuery, GetKirsSummaryGQL, GetKirsSummaryQuery, OperatorInput, PagingInput } from "../../../graphql/generated";
import { map, Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class KirsSummaryService {
    private readonly GetKirsSummaryGQL: GetKirsSummaryGQL = inject(GetKirsSummaryGQL);
    private readonly ExportKirsSummaryGQL: ExportKirsSummaryGQL = inject(ExportKirsSummaryGQL);

    getKirsSummary(campaignId: string, attestationId: string, parameters: any): Observable<GetKirsSummaryQuery['getConformanceKIRsAttestationSummary']> {
        const params = convertLazyLoadToComplex(parameters)
        return this.GetKirsSummaryGQL.fetch({ campaignId, attestationId, page: params.page, query: params?.query }, { fetchPolicy: 'no-cache' }).pipe(map(res => res.data.getConformanceKIRsAttestationSummary))
    }

    exportKirsSummary(campaignId: string, attestationId: string, timeZone: string, parameters: any): Observable<ExportKirsSummaryQuery['downloadConformanceKIRsAttestationSummaryExcel']> {
        const params = convertLazyLoadToComplex(parameters)
        return this.ExportKirsSummaryGQL.fetch({ attestationId, campaignId, query: params.query, timeZone }, { fetchPolicy: 'no-cache' }).pipe(map(res => res.data.downloadConformanceKIRsAttestationSummaryExcel))
    }
}

export function convertLazyLoadToComplex(parameters: any): { query: ConformanceToKiRsSummaryQueryComplexInput, page: PagingInput } {
    const query: ConformanceToKiRsSummarySimpleQueryInput[] = [];
    if (parameters) {

        if (parameters.filters) {

            Object.entries(parameters.filters).forEach(([field, values]) => {
                //console.log"value", values);

                if (values !== null && Array.isArray(values) && values.length > 0) {
                    (ENUM_KIRS_SUMMARY[field as keyof typeof ENUM_KIRS_SUMMARY]).forEach(key => {

                        query.push({
                            field: key as ConformanceToKiRsSummaryField,
                            filters: {
                                operator: [ConformanceToKiRsSummaryField.KirsSummaryStandardOrder, ConformanceToKiRsSummaryField.KirsSummaryStandardRatingQuantitative]?.includes(key) ? ComparatorOperators.Eq : ComparatorOperators.Match,
                                value: values?.map(v => String(v)?.toLowerCase() === 'empty' ? null : key === ConformanceToKiRsSummaryField.KirsSummaryStandardRatingQualitative ? v?.replace(' ', '_') : v)
                            }
                        });
                    })
                }
            });
        }
    }
    return {
        query: {
            operator: OperatorInput.And,
            query: [
                {
                    query,
                    operator: OperatorInput.And
                }
            ]
        },
        page: {
            pageNo: parameters?.page ?? 0,
            pageSize: parameters?.rows ?? 20
        }
    }
}

export const ENUM_KIRS_SUMMARY = {
    order: [ConformanceToKiRsSummaryField.KirsSummaryStandardOrder],
    kir: [ConformanceToKiRsSummaryField.KirsSummaryStandardKir],
    auditPolicyParagraph: [ConformanceToKiRsSummaryField.KirsSummaryStandardPolicy],
    ratingQuantitative: [ConformanceToKiRsSummaryField.KirsSummaryStandardRatingQuantitative],
    ratingQualitative: [ConformanceToKiRsSummaryField.KirsSummaryStandardRatingQualitative]
}